module.exports = __webpack_public_path__ + "img/equipment-Cap-03.e3ddc7f3.png";